module.exports = __webpack_public_path__ + "static/meta-image-942f8dddda9663f4b9057e19cda41328.jpg";